import Ext from "Ext";

/**
 * Abstract selector tree node.
 */
const SelectorTreeNode = Ext.extend(Ext.Container, {
    /**
     * @cfg {String} selectedCls style class for the "selected" state.
     */
    cls: "at-selector-tree-node",
    selectedCls: "at-selected-item",
    layout: "table",
    autoEl: "div",
    layoutConfig: {
        columns: 1
    },

    selected: false,
    children: [],

    /**
     * @cfg {String} selectedProperty enclosed item's "selected" property name.
     */
    selectedProperty: "selected",

    /**
     * @cfg {String} activeProperty enclosed item's "active" property name.
     */
    activeProperty: "active",

    /**
     * @cfg {String} hiddenProperty enclosed item's "hidden" property name.
     */
    hiddenProperty: "hidden",

    initComponent: function() {
        SelectorTreeNode.superclass.initComponent.call(this);

        this.nodeBody = this.getNodeBody();
        this.add(this.nodeBody);

        Ext.each(this.children, function(child) {
            this.add(child);
            child.parent = this;
        }, this);
    },

    /**
     * (De)selects current node.
     * @param {Boolean} value true to select, false to deselect.
     */
    doSelect: function(value) {
        if (value) {
            this.nodeBody.addClass(this.selectedCls);
        } else {
            this.nodeBody.removeClass(this.selectedCls);
        }
    },

    /**
     * (De)selects current node and propagates the action up (only deselection) and/or down the tree.
     * @param {Boolean} value true to select, false to deselect, defaults to true.
     * @param {Boolean} propagateUp false to not propagate deselection up, defaults to true.
     * @param {Boolean} propagateDown false to not propagate down, defaults to true.
     */
    select: function(value, propagateUp, propagateDown) {
        value = value !== false;
        propagateUp = propagateUp !== false;
        propagateDown = propagateDown !== false;

        this.doSelect(value);

        if (propagateDown && this.children) {
            Ext.each(this.children, function(child) {
                child.select(value, false, true);
            }, this);
        }

        if (propagateUp && !value && this.parent) {
            this.parent.select(false, true, false);
        }
    },

    /**
     * Propagates filtering action to the node's children.
     * @param condition filter condition, should return true to keep, false to filter out.
     * @param scope scope to run the filter function in.
     */
    filter: function(condition, scope) {
        if (this.children) {
            Ext.each(this.children, function(child) {
               child.filter(condition, scope); 
            });
        }
    },

    /**
     * @returns {Ext.Component} component to render at the node's position in the tree.
     * @private
     */
    getNodeBody: Ext.emptyFn
});

export default SelectorTreeNode;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_tree_node.js